import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutoLinkUrlPipe } from './auto-link-url.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { UriService } from './uri.service';

@NgModule({
  imports: [CommonModule],
  declarations: [AutoLinkUrlPipe, SafeUrlPipe],
  providers: [UriService],
  exports: [AutoLinkUrlPipe, SafeUrlPipe],
})
export class UriModule {}
